import { action } from 'typesafe-actions';
import * as constants from './constants';
import * as models from '../../models';
import { AD_Invoice_Selector } from '../../models/enums'; 

export const requestAdjusterInvoices = (adjusterId: number, invoiceSelector: AD_Invoice_Selector) =>
    action(constants.REQUEST_ADJUSTER_INVOICES, { adjusterId, invoiceSelector }); 
export const receiveAdusterInvoices = () =>
    action(constants.RECEIVE_ADJUSTER_INVOICES); 
export const receiveAdjusterInvoicesFailure = () =>
    action(constants.RECEIVE_ADJUSTER_INVOICES_FAILURE);
export const clearAdjusterDashboard = () =>
    action(constants.CLEAR_ADJUSTER_DASHBOARD); 

export const requestAdjusterDashboard = (adjusterId: number, invoiceSelector: AD_Invoice_Selector) =>
    action(constants.REQUEST_ADJUSTER_DASHBOARD, { adjusterId, invoiceSelector });
export const receiveAdjusterDashboard = (response: models.AdjusterDashboard) => 
    action(constants.RECEIVE_ADJUSTER_DASHBOARD, { response }); 
export const receiveAdjusterDashboardFailure = () =>
    action(constants.RECEIVE_ADJUSTER_DASHBOARD_FAILURE);

export const requestAdminDashboard = () =>
    action(constants.REQUEST_ADMIN_DASHBOARD); 
export const receiveAdminDashboard = (response: models.AdminDashboard) =>
    action(constants.RECEIVE_ADMIN_DASHBOARD, { response }); 
export const receiveAdminDashboardFailure = () =>
    action(constants.RECEIVE_ADMIN_DASHBOARD_FAILURE);

export const requestMonthlyClaimActivity = (monthsBack: number, months: number) =>
    action(constants.REQUEST_MONTHLY_CLAIM_ACTIVITY, { monthsBack, months }); 

export const receiveMonthlyClaimActivity = (response: models.MonthlyClaimActivityResponse) => 
    action(constants.RECEIVE_MONTHLY_CLAIM_ACTIVITY, { response }); 

export const requestPayrollDashboard = () => 
    action(constants.REQUEST_PAYROLL_DASHBOARD); 
export const receivePayrollDashboard = (response: models.PayrollDashboard) => 
    action(constants.RECEIVE_PAYROLL_DASHBOARD, { response }); 
export const receivePayrollDashboardFailure = () =>
    action(constants.RECEIVE_PAYROLL_DASHBOARD_FAILURE);